import {
  FileArchiveIcon,
  FileCodeIcon,
  FileImageIcon,
  FileSpreadsheetIcon,
  FileTextIcon,
  FileTypeIcon,
  PresentationIcon,
  type LucideIcon,
} from 'lucide-react';
import type { FileType } from '../types/files';

export interface FileTypeMeta {
  label: string;
  icon: LucideIcon;
  /** Tint used for the file-type glyph in the table. */
  iconClass: string;
  /** Tint used for the filter chip when active. */
  activeChipClass: string;
}

export const FILE_TYPE_META: Record<FileType, FileTypeMeta> = {
  pdf: {
    label: 'PDF',
    icon: FileTextIcon,
    iconClass: 'text-red-600',
    activeChipClass: 'border-red-600 bg-red-50 text-red-800',
  },
  doc: {
    label: 'DOC',
    icon: FileTypeIcon,
    iconClass: 'text-blue-700',
    activeChipClass: 'border-blue-700 bg-blue-50 text-blue-800',
  },
  xls: {
    label: 'XLS',
    icon: FileSpreadsheetIcon,
    iconClass: 'text-emerald-700',
    activeChipClass: 'border-emerald-700 bg-emerald-50 text-emerald-800',
  },
  csv: {
    label: 'CSV',
    icon: FileSpreadsheetIcon,
    iconClass: 'text-emerald-600',
    activeChipClass: 'border-emerald-600 bg-emerald-50 text-emerald-800',
  },
  img: {
    label: 'IMG',
    icon: FileImageIcon,
    iconClass: 'text-violet-600',
    activeChipClass: 'border-violet-600 bg-violet-50 text-violet-800',
  },
  ppt: {
    label: 'PPT',
    icon: PresentationIcon,
    iconClass: 'text-orange-600',
    activeChipClass: 'border-orange-600 bg-orange-50 text-orange-800',
  },
  txt: {
    label: 'TXT',
    icon: FileTextIcon,
    iconClass: 'text-slate-600',
    activeChipClass: 'border-slate-600 bg-slate-100 text-slate-800',
  },
  html: {
    label: 'HTML',
    icon: FileCodeIcon,
    iconClass: 'text-sky-700',
    activeChipClass: 'border-sky-700 bg-sky-50 text-sky-800',
  },
  zip: {
    label: 'ZIP',
    icon: FileArchiveIcon,
    iconClass: 'text-amber-700',
    activeChipClass: 'border-amber-700 bg-amber-50 text-amber-800',
  },
};

const EXTENSION_MAP: Record<string, FileType> = {
  pdf: 'pdf',
  doc: 'doc',
  docx: 'doc',
  rtf: 'doc',
  xls: 'xls',
  xlsx: 'xls',
  csv: 'csv',
  png: 'img',
  jpg: 'img',
  jpeg: 'img',
  gif: 'img',
  webp: 'img',
  heic: 'img',
  ppt: 'ppt',
  pptx: 'ppt',
  txt: 'txt',
  md: 'txt',
  html: 'html',
  htm: 'html',
  zip: 'zip',
};

export function typeFromExtension(extension: string): FileType {
  return EXTENSION_MAP[extension.toLowerCase()] ?? 'txt';
}

export const FILE_TYPE_ORDER: FileType[] = [
  'pdf',
  'doc',
  'xls',
  'csv',
  'img',
  'ppt',
  'txt',
  'html',
  'zip',
];
